import LyDragList from './src/index.vue'

LyDragList.install = function (Vue) {
    Vue.component(LyDragList.name, LyDragList)
}

export default LyDragList



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/drag-list/index.js
// module id = null
// module chunks = 